import { useMemo } from "react";
import roundCustom from "../../Utils/RoundCustom";

export default function useTotais(itens, pagamentos, valoresExtras) {

  const calcularLiquido = (produtos, valoresExtrasInterno) => {

    const descontoVenda = (!!valoresExtrasInterno ? valoresExtrasInterno.descontoVenda : valoresExtras?.descontoVenda) || 0;
    const acrescimo = (!!valoresExtrasInterno ? valoresExtrasInterno.acrescimo : valoresExtras?.acrescimo) || 0;
    const valorFrete = (!!valoresExtrasInterno ? valoresExtrasInterno.valorFrete : valoresExtras?.valorFrete) || 0;

    return roundCustom((produtos || []).reduce((a, b) => a + b.valorTotal, 0) - descontoVenda + acrescimo + valorFrete);
  };

  const totaisPrd = useMemo(() => {
    return {
      itens: roundCustom((itens || []).reduce((a, b) => a + b.qtd + b.qtdExtra, 0)),
      valorTotalProduto: roundCustom((itens || []).filter(x => !x.isServico).reduce((a, b) => a + b.valorTotal, 0)),
      valorTotalServico: roundCustom((itens || []).filter(x => x.isServico).reduce((a, b) => a + b.valorTotal, 0)),
      unitario: roundCustom((itens || []).reduce((a, b) => a + b.valorUn, 0)),
      liquido: calcularLiquido(itens),
      desconto: roundCustom((itens || []).reduce((a, b) => a + b.desconto, 0)),
      descontoProduto: roundCustom((itens || []).filter(x => !x.isServico).reduce((a, b) => a + b.desconto, 0)),
      descontoServico: roundCustom((itens || []).filter(x => x.isServico).reduce((a, b) => a + b.desconto, 0)),
      bruto: roundCustom((itens || []).reduce((a, b) => a + (b.valorUn * (b.qtdPaga || b.qtd)), 0)),
    };

  }, [itens, valoresExtras]);

  const totaisPgto = useMemo(() => {
    if (!pagamentos)
      return {};

    var total = roundCustom(pagamentos.reduce((a, b) => a + b.recebido, 0));

    return {
      total,
      troco: total <= totaisPrd.liquido ? 0 : roundCustom(-(totaisPrd.liquido - total))
    };

  }, [pagamentos, itens, valoresExtras]);

  return { ...totaisPrd, ...totaisPgto, calcularLiquido };
}